var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-stripe 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.7917 3.5H7.20833C5.43908 3.5 4 4.93967 4 6.70833V21.2917C4 23.0603 5.43908 24.5 7.20833 24.5H21.7917C23.5609 24.5 25 23.0603 25 21.2917V6.70833C25 4.93967 23.5609 3.5 21.7917 3.5ZM14.2083 20.4167C12.9197 20.4167 11.6218 20.0842 10.6097 19.7342C10.4925 19.6939 10.4167 19.5831 10.4167 19.4588V16.7399C10.4167 16.6355 10.5217 16.5637 10.6173 16.6052C11.2981 16.898 12.5237 17.36 13.7282 17.4866C14.2807 17.5443 14.8226 17.4837 15.1277 17.1675C15.2338 17.0573 15.3744 16.8327 15.3744 16.4926C15.3744 16.2318 15.3237 15.6211 13.8962 15.2011C12.6123 14.8412 10.125 14.0128 10.125 11.375C10.125 9.62617 11.3471 7.58333 14.7917 7.58333C16.0802 7.58333 17.3782 7.91583 18.3903 8.26583C18.5075 8.30608 18.5833 8.41692 18.5833 8.54117V11.2548C18.5833 11.3598 18.4777 11.431 18.3821 11.389C17.7043 11.0927 16.4827 10.6283 15.2782 10.5216C14.7333 10.4522 14.1407 10.5047 13.8513 10.7893C13.7574 10.8815 13.625 11.0676 13.625 11.3394C13.625 11.5628 13.632 12.0616 15.0769 12.5008C17.5975 13.2364 18.875 14.5734 18.875 16.4786C18.875 18.2957 17.6529 20.4167 14.2083 20.4167Z",
    fill: "#635BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.56374d901ec701b5cbb59a918072fce1.svg";
export { ForwardRef as ReactComponent };